import { Component, OnInit, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CurrencyPipe } from '@angular/common';
import { CompletePaymentSepaDto } from '../../../shared/models/dtos/complete-payment/complete-payment-sepa.dto';
import { ContactComponent } from '../../../shared/components/contact/contact.component';
import { BannerComponent } from '../../../shared/components/banner/banner.component';
import { Themes } from '../../../../themes';
import { BackendErrorType } from '../../../shared/services/errors/backend.errors';
import { HandlebarsPipe } from '../../../shared/pipes/templating/handlebars.pipe';
import { FeeInfoBoxComponent } from './fee-info-box/fee-info-box.component';
import { SepaInputBoxComponent } from './sepa-input-box/sepa-input-box.component';
import { MainLayoutComponent } from 'app/shared/components/layouts/main-layout/main-layout.component';
import { LandingpageConfiguration } from 'app/shared/models/landingpage-configuration.model';
import { BackendService } from 'app/shared/services/backend.service';
import { ibanValidator } from 'app/shared/components/iban-input/iban-input.validator';
import { SepaDataService } from 'app/shared/services/sepa-data.service';

@Component({
  selector: 'ez-sepa-detail',
  imports: [
    MainLayoutComponent,
    FeeInfoBoxComponent,
    SepaInputBoxComponent,
    ContactComponent,
    BannerComponent,
    HandlebarsPipe,
  ],
  providers: [CurrencyPipe],
  templateUrl: './sepa-detail.component.html',
  styleUrl: './sepa-detail.component.scss',
})
export class SepaDetailComponent implements OnInit {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private formBuilder = inject(FormBuilder);
  private backendService = inject(BackendService);
  private sepaDataService = inject(SepaDataService);
  private destroyRef = inject(DestroyRef);

  landingpageConfig: LandingpageConfiguration;
  paymentAmount: number;
  form: FormGroup;

  ngOnInit(): void {
    this.route.data.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (data) => {
        this.landingpageConfig = data['landingPageConfiguration'];
      },
    });
    this.paymentAmount = this.sepaDataService.getPaymentAmount();
    this.form = this.formBuilder.group({
      iban: ['', [Validators.required, ibanValidator]],
      givesSepaMandate: [false, Validators.requiredTrue],
    });
  }

  onBackToOverview() {
    this.router.navigate(['case']);
  }

  onSubmit() {
    const givesSepaMandate = this.form.controls['givesSepaMandate'].value;
    if (givesSepaMandate) {
      const iban: string = this.form.controls['iban'].value.replaceAll(' ', '');
      const payload: CompletePaymentSepaDto = {
        iban: iban,
        reference: this.landingpageConfig.reference,
        amount: this.paymentAmount,
      };
      this.backendService
        .completePaymentSepa(payload)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: () => this.router.navigate(['completed']),
          error: (error) => {
            if (error.message === BackendErrorType.ALREADY_SENT) {
              this.router.navigate(['already-sent']);
            } else if (error.message === BackendErrorType.VERIFICATION_ERROR) {
              this.router.navigate(['verification-error']);
            } else {
              this.form.setErrors({ [error.message]: true });
            }
          },
        });
    }
  }

  protected readonly Themes = Themes;
}
